import {
  Autocomplete,
  Button,
  FormControl,
  IconButton,
  Stack,
  TextField,
  useTheme,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'
import { fsColors } from '../../../../shared/constants'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { setEtlValueMappings } from '../../../../store/actions'

const FsNewVariableGroup = ({ setOpen }: { setOpen: (isOpen: boolean) => void }) => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const { etlFileCharacteristics, etlValueMappings } = useAppSelector((state) => state.currentEtl)
  const { t } = useTranslation()

  const options =
    etlFileCharacteristics
      ?.filter((characteristic) => characteristic.isShown)
      .map((characteristic) => ({ label: characteristic.name, id: characteristic.id })) ?? []

  const addVariableTemp = (newCharacteristic: { label: string; id: number }) => {
    if (etlValueMappings)
      dispatch(
        setEtlValueMappings([
          ...etlValueMappings,
          {
            id: newCharacteristic.id,
            name: newCharacteristic.label,
            mappings: [],
          },
        ]),
      )
    setOpen(false)
  }

  return (
    <Stack
      borderRadius={2}
      p={2}
      gap={1}
      sx={{
        backgroundColor: theme.palette.action.disabledBackground,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ display: 'flex', width: '100%' }}
            gap={1}
          >
            <FormControl
              size="small"
              sx={{
                backgroundColor: theme.palette.background.paper,
                width: 300,
              }}
            >
              <Autocomplete
                size="small"
                sx={{ width: 300, backgroundColor: theme.palette.background.paper }}
                options={options}
                defaultValue={null}
                renderInput={(params) => <TextField {...params} label={t('column.select')} />}
                onChange={(_, newValue: { label: string; id: number } | null) => {
                  if (newValue) addVariableTemp(newValue)
                }}
              />
            </FormControl>
          </Stack>
        </Stack>
        <Stack justifyContent="flex-end" direction="row">
          <Button
            disabled
            startIcon={<AddIcon />}
            sx={{
              backgroundColor: fsColors.fsGray.colors[2],
              color: fsColors.fsGray.colors[0],
            }}
          >
            {t('group.add')}
          </Button>
          <IconButton disabled>
            <DeleteIcon />
          </IconButton>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default FsNewVariableGroup
